import { CajaPolicy } from "./policy";

export const cajaPolicy = new CajaPolicy()